
<div class="watermark" *ngIf="env.DEMO != ''">{{env.DEMO}}</div>

<div class="demo-banner" *ngIf="env.DEMO != ''">
<div class="scroll-text">
    ⚠️ {{env.DEMO}} - This environment is for demonstration purposes only. Data shown is not real and may be reset at any time.
</div>
</div>

<div style="height:100%;display: flex;align-items: center;justify-content: center;
font-family:'Inter';background-color:#fafafa;text-align: center;">
    <div>
        <h1 style="font-weight: bold;font-size:70px;">404</h1>
        <p style="color:#0000008c;font-size:13px;">Oops... The page you are looking for doesn't exist</p>
        <button routerLink="" routerLinkActive="active" pButton pRipple label="Go Back" class="addButton"> 
            <i class="pi pi-arrow-left" style="font-size: 0.8em; padding-left:15px"></i>
        </button>
    </div>
</div>